<template>
  <div style="min-height: 100vh;" class="c-white-background">
    <MainNavBarWapV2 :object-data="infoHeader" />
    <div class="container top-spacing colum">
      <el-row v-loading="isLoading" class="post-container" :gutter="20">
        <el-col :xs="24" :sm="14" :md="14" :lg="16" :xl="16">
          <div>
            <p class="m-0 title-post fw-600 text-uppercase">{{ info.title }}</p>
          </div>
          <div class="excerpt-post mt-20">
            <p class="m-0 ">"{{ info.title }}"</p>
          </div>
          <div class="content-post mt-20">
            <p v-html=processedContent></p>
          </div>
        </el-col>
        <el-col :xs="24" :sm="10" :md="10" :lg="8" :xl="8">
          <div class="top-post-container mb-20">
            <p class="fw-600 m-0 text-uppercase c-body">
              {{ $t("wap.text174") }}
            </p>
          </div>
          <card-news
            v-for="(item, index) in listNews.slice(0, 6)"
            :key="index"
            style="margin-bottom: 15px;"
            class="w-100"
            :object-data="item"
            :excerpt="item.excerpt"
            :title="item.title"
            :banner="item.banner"
            :id="item.post_id"
          />
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import { getBackGround } from "@/utils/wapAuth";
import MainNavBarWapV2 from "@/layout/WapV2/MainNavBar.vue";
import CardNews from "@/components/wapV2/cards/CardNews.vue";
import ReviewFacility from "@/views/api/wapV2/review-facility";

export default {
  components: {
    MainNavBarWapV2,
    CardNews
  },
  name: "page-detail-news",
  props: {
    isShow: {
      type: Boolean,
      default: true
    }
  },
  created() {
    this.onGetDetail();
    this.onGetTopPost();
  },
  data() {
    return {
      isLoading: false,
      bg: getBackGround(),
      infoHeader: {
        title: this.$t("wap.text148"),
        isShowHomeIcon: true
      },
      listNews: [],
      domain: 'https://vnewstoday.com',
      info: {}
    };
  },
  watch: {
    "$route.params.id"(newVal, oldVal) {
      this.onGetDetail();
    }
  },
  computed: {
    processedContent() {
      if (!this.info.content) return '';

      if (typeof window === 'undefined') {
        return this.info.content; 
      }

      const div = document.createElement('div');
      div.innerHTML = this.info.content;

      const images = div.querySelectorAll('img');
      images.forEach((img) => {
        const src = img.getAttribute('src');
        // src và src không bắt đầu bằng http/https, không bắt đầu bằng base64
        if (src && !src.startsWith('http') && !src.startsWith('//') && !src.startsWith('data:')) {
          const newSrc = src.startsWith('/') ? `${this.domain}${src}` : `${this.domain}/${src}`;
          img.setAttribute('src', newSrc);
        }
      });

      const links = div.querySelectorAll('a');
      links.forEach((link) => {
        const href = link.getAttribute('href');
        if (href && !href.startsWith('http') && !href.startsWith('//') && !href.startsWith('#') && !href.startsWith('mailto:') && !href.startsWith('tel:')) {
           const newHref = href.startsWith('/') ? `${this.domain}${href}` : `${this.domain}/${href}`;
           link.setAttribute('href', newHref);
        }
      });
      return div.innerHTML;
    }
  },
  methods: {
    onGetDetail() {
      this.isLoading = true;
      ReviewFacility.get_detail_post({ id: this.$route.params.id })
        .then(res => {
          const { error_code, data } = res;
          if (error_code === 0) {
            this.info = data.post;
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    onGetTopPost() {
      ReviewFacility.get_top_post()
        .then(res => {
          const { error_code, data = [] } = res;
          if (error_code === 0 && data.length > 0) {
            const mapData = data.map(i => {
              const obj = {
                ...i,
                id: i.course_id,
                title: i.post.title,
                excerpt: i.post.excerpt,
                banner: i.post.banner
              };
              return obj;
            });
            this.listNews = mapData;
          }
        })
        .finally(() => {});
    }
  }
};
</script>

<style lang="scss" scoped>
.post-container {
  .top-post-container {
    background: #f0f0f0;
    border-left: 4px solid #111827;
    padding: 8px 15px;
    color: #111827;
    font-size: 16px;
    font-weight: 700;
  }
  .excerpt-post {
    border-left: 4px solid #c9c7c7;
    padding-left: 10px;
    font-style: italic;
    line-height: 18px;
  }
  .title-post {
    font-size: 20px;
  }
}
.top-spacing {
  padding-top: 100px;
}
.full-width {
  width: 100%;
}
.divider-view-top {
  height: 15px;
  width: 100%;
}

.column {
  flex-direction: column;
}

.desktop {
  display: block;
}

.mobile {
  display: none;
}
.golf-good-price {
  padding: 0;
  margin: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .title-h3 {
    font-size: 16px;
  }
}
@media screen and (min-width: 0px) and (max-width: 480px) {
}
@media screen and (min-width: 0px) and (max-width: 769px) {
  .post-container {
    .title-post {
      font-size: 18px;
    }
  }
  .desktop {
    display: none;
  }
  .mobile {
    display: block;
  }
  .top-spacing {
    padding-top: 65px;
  }
  .top-spacing1 {
    padding-top: 170px;
  }
  .title-h3 {
    font-size: 14px;
  }
}
@media screen and (min-width: 0px) and (max-width: 980px) {
  .title-section {
    display: none;
  }
}
</style>
